<div class="row eip-pt-20 eip-pt-xs-0">
  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
    <EIPAutoComplete ShowTextValueField='N' TextField="group_Name"  ValueField="group_Id" WaterMarkText="Business Group"
      [dataSource]='businessGroupList' setId="ddBusinessGrpId" (valueChange)='changeBusinessGroup($event)'
      [IsCascading]='true'>
    </EIPAutoComplete>

  </div>
  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
    <EIPAutoComplete ShowTextValueField='N' TextField="group_Name"  ValueField="group_Id"
      WaterMarkText="Project Business Group" [dataSource]='projectBusinessGroupList' setId="ddDiscpId"
      (valueChange)='changeProjectBusinessGroup($event)' [IsCascading]='true'>
    </EIPAutoComplete>
  </div>
</div>


<div class="row">
  <div class="col-md-12 d-none d-md-block  eip-mb-15">
    <hr>
  </div>
  <div class="offset-md-2  offset-sm-0  col-md-6">
    <EIPGeneralCart [CartParameters]="cartRequest" (OnCartSubmit)='getSelectedCartItems($event)'
      (OnClick)='setCartParams()'>
    </EIPGeneralCart>
  </div>

</div>